import React, { useState, useEffect } from 'react';
import './App.css';
import QuizDashboard from './pages/QuizDashboard';

const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const TENANT_ID = 'demo-university';

function App() {
  const [universityName, setUniversityName] = useState('');

  useEffect(() => {
    fetch(`${API_ROOT}/api/tenant/${TENANT_ID}`)
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (data?.tenant?.branding?.universityName) {
          setUniversityName(data.tenant.branding.universityName);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="app-root">
      <QuizDashboard universityName={universityName} />
    </div>
  );
}

export default App;